import React from "react"
import { Link } from "gatsby"
import styled from "styled-components"

import Logo from "@components/Logo"
import Stopper from "@components/Stopper"

const Header = ({ location }) => {
  return (
    <Wrapper>
      <Stopper>
        <Link to="/" className="logo-link">
          <Container>
            <LogoContainer>
              <Logo />
            </LogoContainer>
            <Heading>Contentful Explore</Heading>
          </Container>
        </Link>
      </Stopper>
    </Wrapper>
  )
}

export default Header

const Wrapper = styled.div`
  background: ${props => props.theme.colors.header};
  padding: 16px 0;
  width: 100%;
`
const LogoContainer = styled.span`
  display: inline-block;
  height: 4rem;
  width: 4rem;
`

const Heading = styled.h1`
  color: ${props => props.theme.colors.white};
  font-size: 1.6rem;
`

const Container = styled.nav`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 18rem;
`
